import { Record } from 'immutable';
import InventoryRecord from './InventoryRecord';

const OrderItemDefaults = {
  id: null,
  quantity: null,
  inventory_record: null,
  total_in_cents: null,
  total_text: null
};

class OrderItem extends Record(OrderItemDefaults) {
  constructor(values) {
    values.inventory_record = new InventoryRecord(values.inventory_record);

    super(values);
  }
}

export default OrderItem;



// WEBPACK FOOTER //
// banquet/models/OrderItem.js